import DateFnsUtils from '@date-io/date-fns';
import {
  Button, Card, CardContent,
  CardHeader,
  CircularProgress, Container,
  createTheme,
  Dialog,
  DialogActions, DialogContent, DialogContentText, DialogTitle,
  Divider,
  FormControl,
  Grid,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getDifferenceInDays, getUser, sc } from 'src/utils/Common';
import logger from 'src/utils/logger';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  contentMaterialImage: {
    padding: 5,
    minHeight: 580,
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitMaterialImage: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  container: {
    maxHeight: 440,
  },
}));

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    },
  },
});
const localeMap = {
  tr: trLocale,
};

function OneTimeService() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [Uyari, setUyari] = React.useState("");
  const [ResponseData, setResponseData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(today);
  const [bitisTarihi, setBitisTarihi] = React.useState(today);
  const [ToplamFis, setToplamFis] = React.useState(0);
  const [ZiyaretAdet, setZiyaretAdet] = React.useState(0);
  const [FisZiyaretAdet, setFisZiyaretAdet] = React.useState(0);
  const [VerimsizlikOran, setVerimsizlikOran] = React.useState(0);
  const [TeknisyenData, setTeknisyenData] = React.useState([]);
  const [ResponseDataFull, setResponseDataFull] = React.useState([]);
  const [TeknisyenValue, setTeknisyenValue] = React.useState("");






  const SessionUser = getUser();
  const handleClose = () => {
    setOpen(false);
  };

  const handleDateChange = (event, type) => {
    var Deger = moment(event).format("YYYY-MM-DD");
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };
  const handleSearch = () => {
    if (getDifferenceInDays(new Date(baslangicTarihi), new Date(bitisTarihi)) > 30) {
      setUyari("İki tarih aralığı 30 günden büyük olamaz!...");
      setOpen(true);
      return
    }
    setLoading(true);
    axios.get('/GetOneTimeService/' + SessionUser.ServiceShopId + "/" + SessionUser.OrganizationUserId + "/" + moment(baslangicTarihi).format("DD.MM.YYYY") + "/" + moment(bitisTarihi).format("DD.MM.YYYY"))
      .then(response => {
        const Data = response.data;
        if (Data.length === 0) {
          setResponseData([]);
          setResponseDataFull([]);
        } else {
          setResponseData(Data);
          setResponseDataFull(Data);
          var TeknisyenData1 = [];

          Data.forEach(item => {
            const kontrol = TeknisyenData1.filter(d => d.KUL_TEK_KODU === item.KUL_TEK_KODU);
            if (kontrol.length === 0) {
              TeknisyenData1.push({ 'KUL_TEK_KODU': item.KUL_TEK_KODU, 'TEKNISYEN': item.KUL_TEK_KODU + ' ' + item.ADI + ' ' + item.SOYADI })
            }
          });
          setTeknisyenData(TeknisyenData1);
        }


        // const [ToplamFis, setToplamFis] = React.useState(0);
        // const [ZiyaretAdet, setZiyaretAdet] = React.useState(0);
        // const [FisZiyaretAdet, setFisZiyaretAdet] = React.useState(0);
        // const [VerimsizlikOran, setVerimsizlikOran] = React.useState(0);

        var ToplamFis1 = 0;
        var ZiyaretAdet1 = 0;
        var FisZiyaretAdet1 = 0;
        var VerimsizlikOran1 = 0.00;
        var Adet = 0;
        Data.forEach(item => {
          ToplamFis1 = ToplamFis1 + item.ToplamFis;
          ZiyaretAdet1 = ZiyaretAdet1 + item.ZiyaretAdet;
          FisZiyaretAdet1 = FisZiyaretAdet1 + item.FisZiyaretAdet;
          VerimsizlikOran1 = VerimsizlikOran1 + item.VerimsizlikOran;
          Adet = Adet + 1;
        });

        VerimsizlikOran1 = VerimsizlikOran1 / Adet;

        setToplamFis(ToplamFis1);
        setZiyaretAdet(ZiyaretAdet1);
        setFisZiyaretAdet(FisZiyaretAdet1);
        setVerimsizlikOran(VerimsizlikOran1 * 100);




        setLoading(false);
      }).catch(error => {
        setResponseData([]);
        setResponseDataFull([]);
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
  }


  useEffect(() => {
    var todosData1 = [];
    todosData1 = ResponseDataFull.filter(function (item) {
      return (
        sc(item.KUL_TEK_KODU, TeknisyenValue)
      );
    });
    setResponseData(todosData1);
    // eslint-disable-next-line
  }, [TeknisyenValue]);

  const handleChangeTeknisyen = (e) => {
    setResponseData([]);
    setTeknisyenValue(e.target.value);

  }

  return (
    <Page className={classes.root} title="Bir Defada Hizmet">
      <Container maxWidth="lg">
        <Header />
        <Card>
          <CardHeader title="Bir Defada Hizmet" />
          <Divider />
          <CardContent>
            {loading && <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />}
            <br />
            <Grid container spacing={1}>
              <Grid item xs={6} sm={6}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      label={'Başlangıç Tarihi'}
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yyyy'}
                      variant="outlined"
                      value={baslangicTarihi}
                      onChange={e => handleDateChange(e, 1)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={6} sm={6}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      label={'Bitiş Tarihi'}
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yyyy'}
                      variant="outlined"
                      value={bitisTarihi}
                      onChange={e => handleDateChange(e, 2)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitMaterialImage}
                  onClick={() => handleSearch()}
                  endIcon={<SearchIcon />}>
                  Sorgula
                </Button>
              </Grid>
            </Grid>
            <br />
            <Divider />
            <br />
            <Grid item xs={12} sm={12}>
              <FormControl variant="outlined" fullWidth className={classes.formControl}>
                <Select
                  native
                  onChange={(e) => handleChangeTeknisyen(e)}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  fullWidth
                  value={TeknisyenValue}>
                  <option value="0" defaultValue="0">Teknisyen Seçiniz!...</option>
                  {TeknisyenData.map(p => {
                    return <option key={p.KUL_TEK_KODU} value={p.KUL_TEK_KODU}>{p.TEKNISYEN}</option>
                  })}
                </Select>
                </FormControl>
            </Grid>
          </CardContent>

          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Teknisyen</TableCell>
                  <TableCell align='right'>ToplamFiş</TableCell>
                  <TableCell align='right'>ZiyaretAdet</TableCell>
                  <TableCell align='right'>FişZiyaretAdet</TableCell>
                  <TableCell align='right'>VerimsizlikOran</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ResponseData.sort((a, b) => a.VerimsizlikOran > b.VerimsizlikOran ? -1 : 1).map(row => (
                  <TableRow key={row.KUL_TEK_KODU}>
                    <TableCell>{row.KUL_TEK_KODU} {row.ADI} {row.SOYADI}</TableCell>
                    <TableCell align='right'>{row.ToplamFis}</TableCell>
                    <TableCell align='right'>{row.ZiyaretAdet}</TableCell>
                    <TableCell align='right'>{row.FisZiyaretAdet}</TableCell>
                    <TableCell align='right'>%{(row.VerimsizlikOran * 100).toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell><b>Toplam</b></TableCell>
                  <TableCell align='right'><b>{ToplamFis}</b></TableCell>
                  <TableCell align='right'><b>{ZiyaretAdet}</b></TableCell>
                  <TableCell align='right'><b>{FisZiyaretAdet}</b></TableCell>
                  <TableCell align='right'><b>{VerimsizlikOran}%</b></TableCell>
                </TableRow>
              </TableBody>
            </Table>

          </TableContainer>
        </Card>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description" >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default OneTimeService;
